
import { faPen } from '@fortawesome/pro-duotone-svg-icons';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Paper, Radio, RadioGroup, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, styled } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { sxTableOverflow } from '../../../../assets/styles/CommonSxProps';
import LoadingApp from '../../../../components/LoadingApp';
import ModalAction from '../../../../components/ModalAction';
import { LstDadosContasCadastradas } from '../../../../interfaces/entities/Reembolso/DadosContaBeneficiario';
import { AccountsTableProps } from '../../../../interfaces/props/Financeiro/Reembolso/AccountsTableProps';
import { useAccessibility } from '../../../../Store/contexts/AccessibilityContext';
import AccountModal from './AccountModal';
import { defaultAccount } from './defaultStates';


function AccountsTable(props: AccountsTableProps) {

  const accessibility = useAccessibility();

  const [account, setAccount] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [acc, setAcc] = useState<LstDadosContasCadastradas>(defaultAccount);
  const [open, setOpen] = useState<boolean>(false);
  const [accountIndex, setAccountIndex] = useState<number>(0);
  const [deletedIndex, setDeletedIndex] = useState<number>(-1);
  const [del, setDel] = useState<boolean>(false);
  const [modalAction, setModalAction] = useState<null | {
    handleShowModal?: () => void; textOutlinedButton: string; textContainedButton: string;
    title: string; subTitle?: string; handleOutlinedButton?: () => void; handleContainedButton?: () => void;
  }>(null);

  const [previousIndex, setPreviousIndex] = useState<number>(0);

  useEffect(() => {
    if (props.selectedAccountIndex) {
      handleAccount(props.selectedAccountIndex);
    }
  }, []);

  useEffect(() => {
    if(del && deletedIndex !== -1) {
      setDeletedIndex(-1);
      setDel(false);
      props.handleDelete(deletedIndex);
    }
  }, [del, deletedIndex]);

  useEffect(() => {
    if (!open) {
      const previouslyFocused = document.getElementById(`edit-account-${previousIndex}`);
      if (previouslyFocused instanceof HTMLElement) {
        previouslyFocused.focus();
        console.log('Focused via re-query:', previouslyFocused);
      }
    }
  }, [open, previousIndex]);

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    ...accessibility.textStyleAccessibility,
      fontFamily: 'Unimed-Sans',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
  }));

  const RadioTableCell = styled(TableCell)(({ theme }) => ({
    ...accessibility.textStyleAccessibility,
    width: 'fit-content',
    padding: 0
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: '#F9F9F9'
    },
  }));

  const handleAccount = (accountIndex: string) => {
    setAccount(accountIndex);
    const index: number = Number(accountIndex);
    props.handleAccount(props.dadosContaBeneficiario.lstDadosContasCadastradas[index])
  }

  const handleSelectAccount = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleAccount(event.target.value);
  }

  const handleClose = () => {
    setOpen(false);
  }

  const handleOpenModal = (editedAccount: LstDadosContasCadastradas, index: number) => {
    setPreviousIndex(index);
    setAcc(editedAccount);
    setAccountIndex(index);
    handleAccount(index.toString());
    setOpen(true);
  }

  const handleEditAccount = (editedAccount: LstDadosContasCadastradas) => {
    props.handleEditedAccount(editedAccount, accountIndex);
    setOpen(false);
  }

  const handleDelete = (index: number) => {
    setDeletedIndex(index);
    setModalAction({
      title: 'Excluir conta',
      subTitle: 'Tem certeza que deseja excluir conta?',
      textOutlinedButton: 'Cancelar',
      textContainedButton: 'Excluir',
      handleContainedButton: handleDeleteNotification,
      handleOutlinedButton: handleCloseModalAction,
      handleShowModal: handleCloseModalAction
    })
  }

  const handleCloseModalAction = () => {
    setDel(false);
    setModalAction(null);
  }

  const handleDeleteNotification = () => {
    setDel(true);
    setModalAction(null);
  }

  return (
    <div>
      <LoadingApp showLoading={loading} text={'Salvando dados da conta...'} />
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        name="radio-buttons-group"
        value={account}
        onChange={handleSelectAccount}
      >
        <TableContainer style={accessibility.contrastBorderAccessibility} className='container-table-result-exam' sx={sxTableOverflow} component={Paper}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <RadioTableCell />
                <StyledTableCell><b>Banco</b></StyledTableCell>
                <StyledTableCell align="left"><b>Agência</b></StyledTableCell>
                <StyledTableCell><b>Número da conta</b></StyledTableCell>
                <StyledTableCell align="left"><b>Tipo</b></StyledTableCell>
                <StyledTableCell><b>Titular</b></StyledTableCell>
                <StyledTableCell align="left"><b>CPF</b></StyledTableCell>
                <StyledTableCell><b>Editar</b></StyledTableCell>
                <StyledTableCell align="left"><b>Excluir</b></StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {props.dadosContaBeneficiario.lstDadosContasCadastradas.map((dados, index) => {
                return (
                  <StyledTableRow
                    key={dados.idCadContaReembolso}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <RadioTableCell >
                      <Radio
                        size='small'
                        name="radio-buttons"
                        key={index}
                        style={accessibility.contrastColorAccessibility}
                        value={index}
                      />
                    </RadioTableCell>
                    <StyledTableCell component="th" scope="row">
                      {dados.banco}
                    </StyledTableCell>
                    <StyledTableCell component="th" scope="row">
                      {dados.agencia}
                    </StyledTableCell>
                    <StyledTableCell component="th" scope="row">
                      {dados.numConta}{dados.digConta}
                    </StyledTableCell>
                    <StyledTableCell component="th" scope="row">
                      {dados.descrTipoConta}
                    </StyledTableCell>
                    <StyledTableCell component="th" scope="row">
                      {dados.nomeTitularConta}
                    </StyledTableCell>
                    <StyledTableCell component="th" scope="row">
                      {dados.cpfTitularConta}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <button
                        id={`edit-account-${index}`}
                        className='accounts-table-button'
                        onClick={() => { handleOpenModal(dados, index) }}
                        aria-label={`editar dados da conta ${dados.agencia} ${dados.numConta}${dados.digConta}`}
                      >
                        <FontAwesomeIcon style={accessibility.contrastColorAccessibility} icon={faPen} />
                      </button>
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <button
                        className='accounts-table-button'
                        onClick={() => { handleDelete(index) }}
                        aria-label={`excluir conta ${dados.agencia} ${dados.numConta}${dados.digConta}`}
                      >
                        <FontAwesomeIcon icon={faTimes} color='#D84141' size='lg' />
                      </button>
                    </StyledTableCell>
                  </StyledTableRow>
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </RadioGroup>
      <AccountModal
        open={open}
        account={acc}
        handleClose={handleClose}
        handleConfirm={handleEditAccount}
        dadosContaBeneficiario={props.dadosContaBeneficiario}
        index={accountIndex} />
      <ModalAction
        showModal={!!modalAction}
        handleShowModal={modalAction?.handleShowModal}
        textOutlinedButton={modalAction?.textOutlinedButton || ''}
        textContainedButton={modalAction?.textContainedButton || ''}
        title={modalAction?.title || ''}
        subTitle={modalAction?.subTitle || ''}
        handleOutlinedButton={modalAction?.handleOutlinedButton}
        handleContainedButton={modalAction?.handleContainedButton}
        icon='error'
      />
    </div>
  )
}

export default AccountsTable;